import axios from "axios";
const instance = axios.create({
    //baseURL: 'http://localhost:8080/portal-djbr/',
    // baseURL: 'http://10.168.252.29:8080/portal-djbr/',
    // baseURL: 'http://10.168.252.29:8080/portal-djbr/',
    baseURL: 'https://portaldjbr.contraloria.gov.py/portal-djbr/',
    headers: {
        "Content-Type": "application/json",
    }
});
export default instance;